import { useId } from 'react';

/**
 * The Klinixis mark: two plates, with the cross cut clean through the front
 * one. Draws in `currentColor`, so set a colour class on it (`text-accent` on
 * light, `text-bg` on green). The back plate is clipped to the front plate's
 * silhouette — it sits behind, so none of it may show through the cross.
 *
 * Below 24 px pass `compact`: the outlined back plate becomes a flat tint
 * before its stroke thins to a hairline. Same geometry as
 * `public/icons/mark.svg` and `public/icons/icon.svg`.
 */
export function Logo({ className, compact = false }: { className?: string; compact?: boolean }) {
  const id = useId().replace(/:/g, '');
  const behind = `${id}-behind`;
  const cross = `${id}-cross`;
  return (
    <svg viewBox="0 0 64 64" className={className} fill="none" role="img" aria-label="Klinixis">
      <mask id={behind} maskUnits="userSpaceOnUse" x="0" y="0" width="64" height="64">
        <rect width="64" height="64" fill="#fff" />
        <rect x="8" y="20" width="36" height="36" rx="11" fill="#000" />
      </mask>
      <mask id={cross} maskUnits="userSpaceOnUse" x="8" y="20" width="36" height="36">
        <rect x="8" y="20" width="36" height="36" rx="11" fill="#fff" />
        <rect x="22.5" y="29" width="7" height="18" rx="3.5" fill="#000" />
        <rect x="17" y="34.5" width="18" height="7" rx="3.5" fill="#000" />
      </mask>
      {compact
        ? <rect x="21.5" y="9.5" width="33" height="33" rx="10" fill="currentColor" fillOpacity="0.42" mask={`url(#${behind})`} />
        : <rect x="21.5" y="9.5" width="33" height="33" rx="10" stroke="currentColor" strokeWidth="5" mask={`url(#${behind})`} />}
      <rect x="8" y="20" width="36" height="36" rx="11" fill="currentColor" mask={`url(#${cross})`} />
    </svg>
  );
}
